<template>
    <div style="width: 360px">
                <v-daterange v-model="range" :presets="presets"
                 :start-label="'Start Date'|translate"
                 :end-label="'End Date'|translate"
                 separator-label=""
                 :disabled="disabled"
                 :title="'Date Range'|translate">
                </v-daterange>
    </div>
</template>

<script>
import moment from 'moment'
  export default {
    name: 'DateRangeSelector',
    props: {
        disabled: {type: Boolean, default: false},
        value: {type: Object},
    },
    watch: {
      value () {
        if(this.range !==this.value){
          this.range = {...this.value}
        }
      },
      range (newRange,oldRange) {
        this.$emit('input', newRange)
          if(newRange&&oldRange&&(newRange.start!=oldRange.start||newRange.end!=oldRange.end)){
              this.$emit('change', newRange)
          }
      }
    },
      created(){
        this.range=this.value&&this.value.start ? {...this.value} : {start:moment().subtract(30, "days").format('YYYY-MM-DD'),end:moment().format('YYYY-MM-DD')}
      },
    mounted () {
      if (!this.value) {
        this.$emit('input', this.range)
      }else if (!this.value.start) {
        this.$emit('input', this.range)
      } else {
        this.range = {...this.value}
      }
    },
    data () {
      return {
        range: null,
        presets: [
        {
          label: this.$options.filters.translate('Today'),
          range: [
              moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
              moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          ]
        },
        {
          label: this.$options.filters.translate('Yesterday'),
          range: [
              moment().subtract(1, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
              moment().subtract(1, "days").endOf('day').format('YYYY-MM-DD HH:mm:ss')
          ]
        },
        {
          label: this.$options.filters.translate('Last 7 Days'),
          range: [
              moment().subtract(7, "days").format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD')
          ]
        },
        {
          label: this.$options.filters.translate('Last 30 Days'),
          range: [
              moment().subtract(30, "days").format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD')
          ]
        }
      ]
      }
    }

  }
</script>

<style>
.v-date-range .v-menu--inline{
    display: block !important;
}
</style>
